import { createSelector } from "reselect";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";

const authorizeUserDomain = state =>
  get(state, "form.AuthorizerForm.values", {});

// ***************************************************************
// ************** authorizeUserForm selectors ******************
// ***************************************************************

export const authorizeUserSelector = createSelector(
  authorizeUserDomain,
  authorizeUser => authorizeUser
);

// ***************************************************************
// *************** authorizeUserForm makeSelect *******************
// ***************************************************************

export const makeSelectAuthorizeUserForm = () => authorizeUserSelector;

export const makeSelectAuthorizerDeliveryPayload = () =>
  createSelector(authorizeUserSelector, formValues => {
    if (isEmpty(formValues)) return {};
    const {
      dob,
      is11BHolder,
      token,
      rEmail,
      rName,
      rNric,
      nric,
      order_user_nric
    } = formValues;

    const payload = {
      token,
      order: {
        doi: dob,
        is11BHolder,
        rEmail,
        rName,
        rNric,
        nric: order_user_nric || nric
      }
    };

    return payload;
  });
